import { createSelector } from 'reselect';

import { mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('user');

export const getUserPasswordUpdate = mount(localState => localState.passwordUpdate);

export const getUserProfile = mount(localState => localState.profile);

export const getUserAvatarSelection = mount(localState => localState.avatarSelection);

const getUserAvatarsById = mount(localState => localState.avatars.byId);

const getUserAvatarsIds = mount(localState => localState.avatars.ids);

export const getUserAvatars = createSelector(
  [getUserAvatarsById, getUserAvatarsIds],
  (userAvatarsById, userAvatarsIds) => userAvatarsIds.map(key => userAvatarsById[key])
);



/** WEBPACK FOOTER **
 ** ./src/members/state/user/selectors.js
 **/